import React, { useState } from 'react';
import {
  Bell,
  Box,
  LayoutDashboard,
  LogOut,
  Menu,
  Package,
  Settings,
  ShoppingBag,
  Users,
  X
} from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BRAND_LOGO } from '../utils/brandAssets';

const links = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/orders', label: 'Orders', icon: ShoppingBag },
  { to: '/inventory', label: 'Inventory', icon: Box },
  { to: '/products', label: 'Products', icon: Package },
  { to: '/customers', label: 'Customers', icon: Users },
  { to: '/notifications', label: 'Notifications', icon: Bell },
  { to: '/settings', label: 'Settings', icon: Settings }
];

export default function Layout() {
  const { admin, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="relative min-h-screen bg-[#f4f5f7] text-slate-900">
      <div className="flex min-h-screen">
        <button
          onClick={() => setMobileOpen(true)}
          className="btn-primary fixed left-4 top-4 z-50 px-3 py-3 md:hidden"
          aria-label="Open menu"
        >
          <Menu size={20} />
        </button>

        <aside
          className={`fixed z-50 flex h-full w-72 flex-col border-r border-slate-200 bg-white p-6 transition-transform duration-300 ease-smooth ${
            mobileOpen ? 'translate-x-0' : '-translate-x-full'
          } md:static md:translate-x-0`}
        >
          <div className="mb-6 flex items-center justify-between md:hidden">
            <h2 className="text-lg font-bold">Menu</h2>
            <button
              onClick={() => setMobileOpen(false)}
              className="btn-ghost px-3 py-2"
              aria-label="Close menu"
            >
              <X size={20} />
            </button>
          </div>

          <div className="animate-fade-up">
            <img
              src={BRAND_LOGO}
              alt="El Cachuchón"
              className="h-9 w-auto object-contain object-left"
            />
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.24em] text-brand-600">
              Admin Operations
            </p>
            <p className="mt-2 text-sm text-slate-500">
              Premium fitted cap commerce backend.
            </p>
          </div>

          <nav className="mt-8 space-y-1.5">
            {links.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'nav-link-active' : 'nav-link-idle'}`
                }
              >
                <Icon size={18} />
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="mt-auto rounded-2xl bg-ink-950 p-4 text-white shadow-lift">
            <p className="font-semibold">{admin?.first_name || 'Admin'}</p>
            <p className="text-sm text-slate-300">{admin?.email}</p>
            <button
              onClick={logout}
              className="btn-secondary mt-4 w-full border-white/10 bg-white/10 text-white hover:bg-white/20"
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </aside>

        <main className="flex-1 p-4 pt-20 md:p-8 md:pt-8">
          <div className="animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
